module.exports = __webpack_public_path__ + "img/banner2_7_zh.ab777f17.png";